module.exports = __webpack_public_path__ + "static/media/button-position-before.87f4bf14.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/rostery/src/button-position-before.png
// module id = 637
// module chunks = 0